import { render, staticRenderFns } from "./WayItem3.vue?vue&type=template&id=0943c292&"
import script from "./WayItem3.vue?vue&type=script&lang=js&"
export * from "./WayItem3.vue?vue&type=script&lang=js&"
import style0 from "./WayItem3.vue?vue&type=style&index=0&id=0943c292&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports